export default "__VITE_ASSET__CLxJLvq5__"